import React from 'react';
import { BellIcon, CameraIcon, IdCardIcon, KeyRoundIcon, MapPinIcon } from 'lucide-react';
import { appBenefits } from '../../data/espace';
import { PhoneMockup } from './PhoneMockup';
const benefitIcons = {
  card: IdCardIcon,
  bell: BellIcon,
  pin: MapPinIcon,
  camera: CameraIcon,
  key: KeyRoundIcon
};
function QrCode() {
  const cells = ['111111011010111111', '100001010110100001', '101101001010101101', '101101011100101101', '100001000110100001', '111111010101111111', '000000011100000000', '110101101011010110', '001011000110101001', '110010111001010110', '011101001101101001', '000000010011010110', '111111011010101001', '100001001101010110', '101101010011101001', '101101101100010110', '100001011011101001', '111111010101010110'];
  return <svg viewBox="0 0 18 18" className="h-28 w-28" role="img" aria-label="QR code to download the app" data-id="element-976" data-mp="145v7f3dwcj8a">
      <rect width="18" height="18" fill="#ffffff" data-id="element-977" data-mp="z7te7pmrb3j3" />
      {cells.map((row, y) => row.split('').map((cell, x) => cell === '1' ? <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill="var(--ville-navy)" data-id="element-978" data-mp="2gfbbjuv4rbci" /> : null))}
    </svg>;
}
export function AppPromo() {
  return <section aria-labelledby="app-title" className="mt-16 grid gap-10 rounded-3xl border border-slate-200 bg-slate-50 p-6 sm:p-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center" data-id="element-979" data-mp="2lcbf9z4ic20g">
      <div data-id="element-980" data-mp="2v6bu4splclmd">
        <h2 id="app-title" className="text-3xl font-extrabold tracking-tight text-ville-navy" data-id="element-981" data-mp="2v6k3wbqf3atc">
          Your dashboard, wherever you go.
        </h2>
        <p className="mt-3 max-w-xl text-[17px] leading-relaxed text-slate-600" data-id="element-982" data-mp="345yt77uulfc9">
          Find your card, your alerts and your services in the Town of Bonnyville’s bciti+ app.
        </p>

        <ul className="mt-7 grid gap-3 sm:grid-cols-2" data-id="element-983" data-mp="19rxy8y2f5chg">
          {appBenefits.map(benefit => {
          const Icon = benefitIcons[benefit.icon];
          return <li key={benefit.id} className="flex items-center gap-3 text-sm text-slate-600" data-id="element-984" data-mp="2i0lllnsklkj7">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl bg-white text-ville-indigo" aria-hidden="true" data-id="element-985" data-mp="2d221lsxjeith">
                  <Icon className="h-4 w-4" data-id="element-986" data-mp="2r2mmcun0iopm" />
                </span>
                {benefit.label}
              </li>;
        })}
        </ul>

        <div className="mt-8 flex flex-wrap items-center gap-5" data-id="element-987" data-mp="30zr6koxasa3s">
          <div className="rounded-2xl border border-slate-200 bg-white p-3" data-id="element-988" data-mp="30xwmtdxrio1a">
            <QrCode data-id="element-989" data-mp="2vzv3crwfcmpa" />
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-990" data-mp="2vyjxmmjf54vj">
            <a href="#app" className="inline-flex items-center rounded-full bg-ville-navy px-6 py-3 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-991" data-mp="39qzvl8xgqcpl">
              Download the app
            </a>
            <a href="#app" className="inline-flex items-center rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo" data-id="element-992" data-mp="2708tsi6ldfk">
              App Store
            </a>
            <a href="#app" className="inline-flex items-center rounded-full border border-slate-300 bg-white px-5 py-3 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo" data-id="element-993" data-mp="3tcjk4ug9zaoj">
              Google Play
            </a>
          </div>
        </div>
      </div>

      <PhoneMockup data-id="element-994" data-mp="3amtpq8gfcqx5" />
    </section>;
}